export { default } from './FormattedDate.js';
export { default as ColoredFormattedDate } from './ColoredFormattedDate.js';



// WEBPACK FOOTER //
// ./src/common/components/FormattedDate/index.js